import { actionTypePrefix } from './constants';
export const ACTION_TYPE_INITIALIZE = `${actionTypePrefix}/INITIALIZE`;
